import { api } from './client'

export const platformLogin = async (username, password) => {
  const { data } = await api.post('/platform/login', { username, password })
  return data
}

export const platformLogout = async () => {
  const { data } = await api.post('/platform/logout')
  return data
}

export const listTenants = async ({ q, status, limit, offset } = {}) => {
  const params = {}
  if (q) params.q = q
  if (status) params.status = status
  if (limit) params.limit = limit
  if (offset) params.offset = offset
  const { data } = await api.get('/platform/tenants', { params })
  return data
}

export const getTenant = async (tenantId) => {
  const { data } = await api.get(`/platform/tenants/${tenantId}`)
  return data
}

export const suspendTenant = async (tenantId, reason) => {
  const { data } = await api.post(`/platform/tenants/${tenantId}/suspend`, { reason })
  return data
}

export const resumeTenant = async (tenantId) => {
  const { data } = await api.post(`/platform/tenants/${tenantId}/resume`)
  return data
}

export const impersonateTenant = async (tenantId) => {
  const { data } = await api.post(`/platform/tenants/${tenantId}/impersonate`)
  return data
}
